/* unplugin-vue-components disabled */import { render } from "./VideoMrtj.vue?vue&type=template&id=6c22e9b8&scoped=true"
import script from "./VideoMrtj.vue?vue&type=script&lang=js"
export * from "./VideoMrtj.vue?vue&type=script&lang=js"

import "./VideoMrtj.vue?vue&type=style&index=0&id=6c22e9b8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c22e9b8"]])

export default __exports__